var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_904_3460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V72H72V0Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0754 31.9876L36.9049 36.1057L41.0754 40.2429L39.9096 41.391L35.7136 37.2789L31.5446 41.3836L30.3562 40.2119L34.5282 36.1057L30.3562 32.0098L31.5446 30.8381L35.7166 34.9236L39.8871 30.8159L41.0754 31.9876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4085 25.0195H45.6016V46.9794H51.4085V25.0195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6175 25.0195H56.8105V46.9794H62.6175V25.0195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1478 25.0195H9.34082V46.9794H15.1478V25.0195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3567 25.0195H20.5498V46.9794H26.3567V25.0195Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_904_3460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthor);
export default __webpack_public_path__ + "static/media/author.9a88664946f2b7aa20b0677c6a7147d6.svg";
export { ForwardRef as ReactComponent };